import React from 'react';
import { View, ScrollView } from 'react-native';
import { connect } from 'react-redux';


import Colors from "../../constants/Colors";
import {SpinnerControl} from "../../components";
import NavBar from "../../components/NavBar";
import TimelineComponent from "./timeline/TimelineComponent";
import CompleteJourneyModal from "./modals/CompleteJourneyModal";
// import TimelineComponent from "./timeline/TimelineComponent";
// import CompleteJourneyModal from "./modals/CompleteJourneyModal";

import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

class JourneyTimelineScreen extends React.Component {

    state = {
        canCompleteJourney: false,
    }

    handleClick = (content) => {
        switch (content.type.toLowerCase()) {
            case "article":
                this.props.history.push(`/journey/timeline/article?contentId=${content.id}`)
                break;

            case "externallink":
                this.props.history.push(`/journey/timeline/externallink?contentId=${content.id}`)
                break;

            case "attendance":
                this.props.history.push(`/journey/timeline/attendance?contentId=${content.id}`, { isCompleted: content.isCompleted });
                break;

            case "webinar":
                this.props.history.push(`/journey/timeline/webinar?contentId=${content.id}`)
                break;

            case "video":
                this.props.history.push(`/journey/timeline/video?contentId=${content.id}`, { isCompleted: content.isCompleted });
                break;

            case "quiz":
                this.props.history.push(`/journey/timeline/quiz?contentId=${content.id}`, { isCompleted: content.isCompleted });
                break;

            case "podcast":
                this.props.history.push(`/journey/timeline/podcast?contentId=${content.id}`, { isCompleted: content.isCompleted });
                break;

            case "enigma":
                this.props.history.push(`/journey/timeline/enigma?contentId=${content.id}`, { isCompleted: content.isCompleted });
                break;
        }
    }

    checkIfCanComplete = () => {

        const { currentJourney, currentUserProgress } = this.props;
        this.setState({ canCompleteJourney: false });

        if (currentJourney !== null && currentUserProgress !== null) {
            if (currentJourney.items.length === currentUserProgress.progress.length) {
                if (currentUserProgress.isCollected === false) {
                    this.setState({ canCompleteJourney: true })
                }
            }
        }

    }

    componentDidMount() {
        this.checkIfCanComplete();
    }

    render() {

        return (
            <NavBar title={`${this.props.currentJourney.title}`}>

                <CompleteJourneyModal
                    isVisible={this.state.canCompleteJourney}
                    onComplete={() => {
                        this.setState({ canCompleteJourney: false })
                        this.props.history.push('/journeys/completed')
                    }}
                />

                <SpinnerControl
                    isFetching={this.props.fetchingCurrentJourneyUserProgress}
                    text={'Carregando dados da trilha!'}
                    textPropsStyle={{ color: 'white' }}
                />

                {
                    (this.props.currentJourney !== undefined && this.props.currentJourney !== null && this.props.currentJourney.items.length !== 0) &&
                        <View style={{ flex: 1, width: 500 }}>
                            <VerticalTimeline
                                layout={'1-column'}
                                animate={false}
                            >
                                {
                                    this.props.currentJourney.items.map((item, index) => {
                                        // console.log(item)
                                        return (
                                            <TimelineComponent
                                                key={index.toString()}
                                                content={item}
                                                onClick={this.handleClick}
                                            />)

                                    })
                                }
                            </VerticalTimeline>
                        </View>

                }

            </NavBar>
        )
    }
}

const mapStateToProps = state => {
    return {
        fetchingCurrentJourneyUserProgress: state.journey.fetchingCurrentJourneyUserProgress,
        currentJourney: state.journey.currentJourney,
        currentUserProgress: state.journey.currentUserProgress
    }
}

export default connect(mapStateToProps)(JourneyTimelineScreen);
